import { FuseNavigationItem } from '@fuse/components/navigation';

// Navegación para rol de administrador
export const adminNavigation: FuseNavigationItem[] = [
    {
        id      : 'ai-assistant',
        title   : 'AI Assistant',
        type    : 'group',
        icon    : 'heroicons_outline:robot',
        children: [
            {
                id   : 'freequest-bot',
                title: 'FreeQuest Bot',
                type : 'basic',
                icon : 'heroicons_outline:robot',
                link : '/ai-chat'
            }
        ]
    },
    {
        id      : 'content',
        title   : 'Content Management',
        type    : 'group',
        icon    : 'heroicons_outline:academic-cap',
        children: [
            {
                id   : 'coursesManagement',
                title: 'Courses',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/admin/courses'
            },
            {
                id   : 'subjectsManagement',
                title: 'Subjects',
                type : 'basic',
                icon : 'heroicons_outline:folder',
                link : '/admin/subjects'
            },
            {
                id   : 'modulesManagement',
                title: 'Modules',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-stack',
                link : '/admin/modules'
            },
            {
                id   : 'lessonsManagement',
                title: 'Lessons',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/admin/lessons'
            }
        ]
    },
    {
        id      : 'packages',
        title   : 'Paquetes',
        type    : 'group',
        icon    : 'heroicons_outline:squares-2x2',
        children: [
            {
                id   : 'packageTemplatesManagement',
                title: 'Package Templates',
                type : 'basic',
                icon : 'heroicons_outline:squares-2x2',
                link : '/admin/package-templates'
            }
        ]
    },
    {
        id      : 'users',
        title   : 'Users',
        type    : 'group',
        icon    : 'heroicons_outline:users',
        children: [
            {
                id   : 'studentsManagement',
                title: 'Estudiantes',
                type : 'basic',
                icon : 'heroicons_outline:academic-cap',
                link : '/admin/students'
            },
            {
                id   : 'tutorsManagement',
                title: 'Tutores',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/admin/tutors'
            },
            {
                id   : 'roleAuditLog',
                title: 'Auditoría de roles',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-list',
                link : '/admin/audit-log'
            }
        ]
    },
    {
        id      : 'reportCards',
        title   : 'Boletines',
        type    : 'group',
        icon    : 'heroicons_outline:document-check',
        children: [
            {
                id   : 'reportCardPending',
                title: 'Por aprobar',
                type : 'basic',
                icon : 'heroicons_outline:inbox-arrow-down',
                link : '/admin/report-cards/pending'
            },
            {
                id   : 'reportCardTransfers',
                title: 'Pagos por validar',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/report-cards/transfers'
            },
            {
                id   : 'reportCardApostille',
                title: 'Para apostillar',
                type : 'basic',
                icon : 'heroicons_outline:archive-box-arrow-down',
                link : '/admin/report-cards/apostille'
            },
            {
                id   : 'reportCardCatalog',
                title: 'Catálogo de materias',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/admin/report-cards/catalog'
            },
            {
                id   : 'reportCardSettings',
                title: 'Configuración',
                type : 'basic',
                icon : 'heroicons_outline:cog-6-tooth',
                link : '/admin/report-cards/settings'
            }
        ]
    },
    {
        id      : 'payments',
        title   : 'Pagos',
        type    : 'group',
        icon    : 'heroicons_outline:credit-card',
        children: [
            {
                id   : 'paymentsManagement',
                title: 'Administración de Pagos',
                type : 'basic',
                icon : 'heroicons_outline:banknotes',
                link : '/admin/payments'
            }
        ]
    },
    {
        id      : 'resources',
        title   : 'Recursos',
        type    : 'group',
        icon    : 'heroicons_outline:link',
        children: [
            {
                id   : 'usefulLinksManagement',
                title: 'Links útiles',
                type : 'basic',
                icon : 'heroicons_outline:link',
                link : '/admin/useful-links'
            }
        ]
    }
];

// Navegación para rol de estudiante
export const studentNavigation: FuseNavigationItem[] = [
    {
        id      : 'ai-assistant',
        title   : 'AI Assistant',
        type    : 'group',
        icon    : 'heroicons_outline:robot',
        children: [
            {
                id   : 'freequest-bot',
                title: 'FreeQuest Bot',
                type : 'basic',
                icon : 'heroicons_outline:robot',
                link : '/ai-chat'
            }
        ]
    },
    {
        id      : 'student-courses',
        title   : 'Mis Cursos',
        type    : 'group',
        icon    : 'heroicons_outline:academic-cap',
        children: [
            {
                id   : 'all-my-courses',
                title: 'Todos mis cursos',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/student/courses',
                exactMatch: true
            },
            {
                id   : 'my-report-card',
                title: 'Mi Boletín',
                type : 'basic',
                icon : 'heroicons_outline:document-chart-bar',
                link : '/student/report-card'
            }
        ]
    },
    {
        id      : 'student-resources',
        title   : 'Recursos',
        type    : 'group',
        icon    : 'heroicons_outline:link',
        children: [
            {
                id   : 'student-useful-links',
                title: 'Links útiles',
                type : 'basic',
                icon : 'heroicons_outline:link',
                link : '/student/useful-links'
            }
        ]
    }
];

// Navegación para rol de tutor
export const tutorNavigation: FuseNavigationItem[] = [
    {
        id      : 'ai-assistant',
        title   : 'AI Assistant',
        type    : 'group',
        icon    : 'heroicons_outline:robot',
        children: [
            {
                id   : 'freequest-bot',
                title: 'FreeQuest Bot',
                type : 'basic',
                icon : 'heroicons_outline:robot',
                link : '/ai-chat'
            }
        ]
    },
    {
        // Issue #17: hasta acá el "Dashboard" del tutor apuntaba a la
        // página de demostración de la plantilla. Ahora es su pantalla de
        // inicio real.
        id      : 'tutor-dashboard',
        title   : 'Dashboard',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link    : '/dashboard'
    },
    {
        id      : 'student-management',
        title   : 'Gestión de Estudiantes',
        type    : 'group',
        icon    : 'heroicons_outline:academic-cap',
        children: [
            {
                id   : 'my-students',
                title: 'Mis Estudiantes',
                type : 'basic',
                icon : 'heroicons_outline:users',
                link : '/tutor/students'
            }
        ]
    }
];

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'ai-assistant',
        title   : 'AI Assistant',
        type    : 'group',
        icon    : 'heroicons_outline:robot',
        children: [
            {
                id   : 'freequest-bot',
                title: 'FreeQuest Bot',
                type : 'basic',
                icon : 'heroicons_outline:robot',
                link : '/ai-chat'
            }
        ]
    },
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'useful-links',
        title: 'Links útiles',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/student/useful-links'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'useful-links',
        title: 'Links útiles',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/student/useful-links'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'useful-links',
        title: 'Links útiles',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/student/useful-links'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },
    {
        id   : 'useful-links',
        title: 'Links útiles',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/student/useful-links'
    }
];
